export default {
  name: "setting-risk"
};